import React from 'react';
import type {SetRequired} from 'type-fest';
import {splitEventHandler} from '@netx/core-next/utils';
import {useConstCallback} from '@netx/core-components/hooks/useEvent';
import {type SwitchProps, Switch} from '@netx/core-components/Switch';
import {useFormInput} from '../hooks';
import type {WithLegacyCommonFormFieldProps} from '../types';

export interface LegacyFormSwitchProps
	extends WithLegacyCommonFormFieldProps<SetRequired<SwitchProps, 'name'>> {}

export const LegacyFormSwitchPrimitive = (
	{error, form, formFieldOptions, onChange, ...props}: LegacyFormSwitchProps,
	ref: any,
) => {
	// TODO: we are not reflecting the error in the ui atm
	const _error = typeof error === 'string' ? error : error?.message;

	useFormInput(props.name, props.checked ?? props.value, form, {
		required: props.required,
		...formFieldOptions,
	});

	const handleChange = useConstCallback(
		splitEventHandler(onChange, (event, value) => {
			form?.setValue(props.name, value);
		}),
	);

	return <Switch ref={ref} {...props} onChange={handleChange} />;
};

export const LegacyFormSwitch = React.forwardRef(LegacyFormSwitchPrimitive);

export default LegacyFormSwitch;
